var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-477.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    stroke: "#006dc9",
    strokeWidth: 1.5,
    cx: 13,
    cy: 13,
    r: 13
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEmpty);
export default __webpack_public_path__ + "static/media/circle-empty.6bea1bd06e095d589d28d80bd5c80172.svg";
export { ForwardRef as ReactComponent };